import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfListaAtendimentosStyle.scss";
import { format } from "date-fns";

function PdfListaAtendimentos({
  listaAtendimentoData,
  medico,
  showPreviousPage,
  clinica,
  dataLista,
  incluirObservacoes,
  unidade,
}) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Lista-Atendimentos-${medico}_${format(
      new Date(),
      "dd-MM-yyyy"
    )}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  return (
    <>
      <div className="full-screen-container">
        <div className="div-teste-above" ref={componentRef}>
          <div className="pdf-listaAtendimentos-heading">
            <h2>{clinica}</h2>
            {/* A unidade a que a lista diz respeito. Uma lista de atendimentos
                é impressa e deitada fora — não se guarda, por isso não leva
                pastilha por linha; mas quem a tem na mão tem de saber de que
                balcão ela é. Só aparece nas clínicas com mais do que uma. */}
            {unidade && <h3>{unidade}</h3>}
            <h3>
              Lista de Atendimentos para
              {dataLista
                ? " " + dataLista
                : " " + format(new Date(), "dd-MM-yyyy")}
            </h3>
            <h3>Médico: {" " + medico}</h3>
            <h3>Nr de Atendimentos: {" " + listaAtendimentoData.length}</h3>
          </div>

          <div className="pdf-listaAtendimentos-grid-container">
            {/* Header */}
            <div
              className={`listaAtendimentos-grid ${
                incluirObservacoes ? "com-observacoes" : ""
              }`}
            >
              <div className="grid-header">Horário</div>
              <div className="grid-header">Cliente</div>
              <div className="grid-header">Contacto</div>
              <div className="grid-header">Procedimento</div>
              {incluirObservacoes && <div className="grid-header">Obs</div>}

              {/* Rows */}
              {listaAtendimentoData.map((l, index) => (
                <>
                  <div className="grid-cell horario">
                    {format(new Date(l.data_inicio_execucao), "HH:mm")} -{" "}
                    {format(new Date(l.data_fim_execucao), "HH:mm")}
                  </div>
                  <div className="grid-cell cliente">{l.cliente}</div>
                  <div className="grid-cell contacto">
                    {l.contacto ? l.contacto : ""}
                  </div>
                  <div className="grid-cell procedimento">{l.procedimento}</div>
                  {incluirObservacoes && (
                    <div className="grid-cell observacoes">
                      {l.observacoesAgendamento}
                    </div>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PdfListaAtendimentos;
